import React from 'react'
import { Box, Text } from '@fundamentals'
import { Tooltip } from '@mui/material'
import { CheckCircleOutlined, HighlightOff } from '@mui/icons-material'
import { localizedStrings } from '@core/strings'
import { Proof } from '@core/entities/template/TemplateQuestion'
import {
  getReviewedAt,
  getReviewerFullName,
  getStatusLabel,
  isDocumentAppraised,
} from '@core/entities/template/TemplateQuestion/submissionDocumentHelpers'

type AppraisalOverlayProps = {
  proof?: Proof
  children: React.ReactElement
}

export const AppraisalOverlay: React.FC<AppraisalOverlayProps> = ({
  proof,
  children,
}) => {
  if (!proof.siteBoxDocument || !isDocumentAppraised(proof)) {
    return children
  }
  const status = proof.siteBoxDocument.documentIntelligence?.status
  const reviewName = getReviewerFullName(proof)
  return (
    <Tooltip
      title={
        <Box>
          <Text fontSize={10} fontWeight={500}>
            {getStatusLabel(proof)}
          </Text>
          {reviewName && (
            <>
              <Text fontSize={10} fontWeight={500}>
                {localizedStrings.reviewedBy} {reviewName}
              </Text>
              <Text fontSize={10} fontWeight={500}>
                {getReviewedAt(proof)}
              </Text>
            </>
          )}
        </Box>
      }
      placement='top'
    >
      <Box sx={{ position: 'relative' }}>
        {children}
        <Box
          sx={{
            position: 'absolute',
            top: 4,
            right: 4,
            backgroundColor: 'common.white',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          {status === 'FAIL' && (
            <HighlightOff
              sx={{
                width: 20,
                height: 20,
                borderRadius: '50%',
                bgcolor: 'error.main',
                color: 'white',
              }}
            />
          )}
          {status === 'PASS' && (
            <CheckCircleOutlined
              sx={{
                width: 20,
                height: 20,
                borderRadius: '50%',
                bgcolor: 'success.main',
                color: 'white',
              }}
            />
          )}
        </Box>
      </Box>
    </Tooltip>
  )
}
